import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import CampaignsList from "@/components/dashboard/CampaignsList";
import EmailConnectModal from "@/components/campaigns/EmailConnectModal";
import { useAuth } from "@/context/AuthContext";
import { CampaignProvider, useCampaign } from "@/context/CampaignContext";
import { SearchProvider } from "@/context/SearchContext";
import { Button } from "@/components/ui/button";
import { Search, Mail, User, Plus, PlusCircle } from "lucide-react";

function DashboardContent() {
  const { user } = useAuth();
  const { isEmailConnected } = useCampaign();
  const navigate = useNavigate();
  const [showEmailConnect, setShowEmailConnect] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Redirect to login if not authenticated
  useEffect(() => {
    if (!user) {
      navigate("/login");
    }
  }, [user, navigate]);

  if (!user) {
    return null;
  }

  return (
    <SearchProvider>
      <CampaignProvider>
        <div className="min-h-screen flex flex-col bg-white">
          <Header />
          <main className="flex-grow container mx-auto px-4 py-8">
            {/* Welcome Section */}
            <div className="mb-8">
              <h4 className="">Welcome back!</h4>
              <p className="text-black  mt-1">
                Manage your lead generation campaigns and track your results
              </p>
            </div>

            {/* Quick Actions */}
            <div className="grid grid-cols-3 gap-4 max-md:gap-2 mb-8">
              <Button
                variant="outline"
                className="h-auto py-6 max-md:py-4 flex  max-md:text-xs flex-col items-center justify-center gap-2 bg-gradient-to-br from-indigo-50 to-indigo-300 hover:bg-indigo-200"
                onClick={() => navigate("/search")}
              >
                <Search className="h-6 w-6" />
                <span>Find New Leads</span>
              </Button>

              {/* <Button
                variant="outline"
                className={`h-auto py-6 max-md:py-4 flex flex-col items-center justify-center gap-2 bg-gradient-to-br from-red-50 to-red-300
                             hover:bg-red-200`}
                onClick={() => navigate("/addemails")}
              >
                <PlusCircle className="h-6 w-6" />
                <span> Add Email</span>
              </Button> */}

              <Button
                variant="outline"
                className="h-auto py-6 max-md:py-4 flex max-md:text-xs  flex-col items-center justify-center gap-2  bg-gradient-to-br from-cyan-50 to-cyan-300   hover:bg-cyan-100"
                onClick={() => navigate("/account")}
              >
                <User className="h-6 w-6" />
                <span>Account Setting</span>
              </Button>

              <Button
                variant="outline"
                className="h-auto py-6 max-md:py-4 flex flex-col max-md:text-xs items-center justify-center gap-2 bg-gradient-to-br from-amber-50 to-amber-300 hover:bg-amber-100"
                onClick={() => navigate("/email-template-manager")}
              >
                <Mail className="h-6 w-6" />
                <span>Email Template</span>
              </Button>
            </div>

            {/* Campaigns List */}
            <div className="bg-white rounded-lg shadow p-4">
              <CampaignsList />
            </div>
          </main>
          <Footer />
        </div>
        <EmailConnectModal
          open={showEmailConnect}
          onClose={() => setShowEmailConnect(false)}
          onSuccess={() => setShowEmailConnect(false)}
        />
      </CampaignProvider>
    </SearchProvider>
  );
}

export default function DashboardPage() {
  return (
    <SearchProvider>
      <CampaignProvider>
        <DashboardContent />
      </CampaignProvider>
    </SearchProvider>
  );
}
